<mat-checkbox
    (click)="click($event)"
    [checked]="checked"
    [color]="checked ? color : ''"
    [disabled]="disabled"
></mat-checkbox>
<label class="mdc-label checkbox-label" [class]="[disabled ? 'disabled' : '']"><ng-content></ng-content></label>
